import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/attendance/reviews/")({
  head: () => ({
    meta: [{ title: "考勤审批 · imiker CRM" }],
  })
});
